import React from 'react';
import { Select } from 'antd';
import { Flex, Typography } from '../common';

const { Option } = Select;

// Reusable Select Component
const CustomSelect = ({
  options,
  placeholder,
  onChange,
  value,
  allowClear = true,
  showSearch = true,
  mode = 'default',
  className = '',
}) => {
  return (
    <div>
      <Select
        mode={mode}
        popupMatchSelectWidth={false}
        showSearch={showSearch}
        placeholder={placeholder}
        onChange={onChange}
        value={value}
        allowClear={allowClear}
        style={{ width: '100%' }}
        size="large"
        className={`[&>div]:!border-primaryPurple ${className}`}
      >
        {options.map((option) => (
          <Option key={option.value} value={option.value}>
            {option.label}
          </Option>
        ))}
      </Select>
    </div>
  );
};

export default CustomSelect;
